<div
  #recordsContainer
  class="records-container"
  [style.width.px]="scrollWidth"
  [style.height.px]="scrollHeight">
  <ng-container *pplVirtualScrollFor="let record of visibleRecords; dataKey: dataKey; startIndex: overscanStartIndex">
    <ng-template
      [ngTemplateOutlet]="dataTemplate"
      [ngTemplateOutletContext]="{
        '\$implicit': record,
        nextRecord: visibleRecords[getRecordIndex(record) + 1],
        extraData: extraData,
        style: getRecordStyle(overscanStartIndex + getRecordIndex(record)),
        index: getRecordIndex(record),
        realIndex: overscanStartIndex + getRecordIndex(record),
        odd: (overscanStartIndex + getRecordIndex(record)) % 2 === 1,
        last: overscanStartIndex + getRecordIndex(record) === data.length - 1,
      }"></ng-template>
  </ng-container>

  @if (recordsContent) {
    <ng-container *ngTemplateOutlet="recordsContent; context: { scrollTop: elementRef.nativeElement.scrollTop }"></ng-container>
  }
</div>

@if (frozenPanes && frozenPanes.length !== 0) {
  @if (frozenPaneTop) {
    <div
      class="frozen-pane-top"
      [style.left.px]="frozenPaneTop.left"
      [style.top.px]="frozenPaneTop.top"
      [innerHTML]="frozenPaneTop.content"></div>
  }
  @for (frozenPaneLeft of frozenPanesLeft; track trackFrozenPane($index, frozenPaneLeft)) {
    <div
      class="frozen-pane-left"
      [style.left.px]="frozenPaneLeft.left"
      [style.top.px]="frozenPaneLeft.top"
      [innerHTML]="frozenPaneLeft.content"></div>
  }
  @if (frozenPaneTopLeft) {
    <div
      class="frozen-pane-top-left"
      [style.left.px]="frozenPaneTopLeft.left"
      [style.top.px]="frozenPaneTopLeft.top"
      [innerHTML]="frozenPaneTopLeft.content"></div>
  }
}
